import { render, staticRenderFns } from "./PaymentDetailsCardBrand.vue?vue&type=template&id=d40d7360&"
import script from "./PaymentDetailsCardBrand.vue?vue&type=script&lang=js&"
export * from "./PaymentDetailsCardBrand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports